import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { getResourcecategories } from '../../../../redux/actions/resourcecategories'
import { viewResource } from '../../../../redux/actions/resources'
import { getResourcetypes } from '../../../../redux/actions/resourcetypes'
import { IRootState } from '../../../../redux/types'
import { MoreInfoDetail } from '../../../backoffice/library/models/resource'
import useGeneralSummaryReport from '../useGeneralSummaryReport'
import useUserDisplaytime from '../useUserDisplaytime'

function useDetailInitialState() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { id } = useParams<{ id: string }>()

  const { globalFamilyId, globalBrandId, globalLanguageId, globalCountriesId } = useSelector((state: IRootState) => state.global)
  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)
  const { resourceSelected } = useSelector((state: IRootState) => state.resource)

  const [favoriteState, setFavoriteState] = useState<boolean>(false)

  useUserDisplaytime({ foreign: resourceSelected })
  const { handleViewGeneralSummaryReport } = useGeneralSummaryReport(2)

  const infoDetail: MoreInfoDetail = {
    item: [
      {
        id: 0,
        type: 'tag',
        title: 'Tags',
        color: 'light',
        info: `${resourceSelected?.tags
          ?.map((tag: any) => {
            return tag.name.toUpperCase()
          })
          .join(', ')}`
      },
      {
        id: 1,
        type: 'file',
        title: `${t('admin.library.file-type')}`,
        color: 'blue',
        info: `${resourceSelected?.ext?.toUpperCase()}`
      },
      {
        id: 2,
        type: 'size',
        title: `${t('admin.library.file-size')}`,
        color: 'orange',
        info: `${(resourceSelected?.filesize / 1000 / 1000).toFixed(2)}MB`
      },
      {
        id: 3,
        type: 'date',
        title: `${t('admin.people.created-date')}`,
        color: 'grey6',
        info: resourceSelected?.upload_date
      }
    ]
  }

  useEffect(() => {
    dispatch(viewResource(id))
  }, [id])

  useEffect(() => {
    if (resourceSelected?.view && resourceSelected.id === Number(id)) {
      handleViewGeneralSummaryReport(resourceSelected.id)
      setFavoriteState(Boolean(resourceSelected.favoriteId))
    }
  }, [resourceSelected])

  useEffect(() => {
    if (globalLanguageId !== null) {
      if (resourcetypes.length === 0) dispatch(getResourcetypes())

      if (resourcetypes.length === 0)
        dispatch(
          getResourcecategories({
            languageId: globalLanguageId,
            countriesId: globalCountriesId,
            familyId: globalFamilyId,
            brandId: globalBrandId
          })
        )
    }
  }, [globalLanguageId])

  return { favoriteState, setFavoriteState, infoDetail }
}

export default useDetailInitialState
